"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var processSelector_1 = __importDefault(require("./processSelector"));
var plainCellRenderer = function (textSelector) {
    return function (item) { return (0, processSelector_1.default)(item, textSelector); };
};
exports.default = plainCellRenderer;
